import { Component, Vue, Prop } from 'vue-property-decorator';
import WithRender from './PaymentResult.html';
import { Inject } from 'vue-di-container';
import TokenService from '../../../Services/TokenService';
import { Toaster } from '../../../Services/toast';
import {
    clearRenewalPaymentRedirectMark,
    getRouteNameFromPaymentReturnTarget,
    takePaymentReturnTarget,
    takeRenewalDashboardSuccessToastPending,
    takeTemplateRenewalsPendingToast,
} from '../../../constants/renewalPaymentRedirect';


@WithRender
@Component({
    components: {
    },
    diProvide: [
        TokenService,
    ],
})
export default class PaymentResult extends Vue {
    @Inject(TokenService) public tokenService!: TokenService;
    @Prop({ type: Boolean, default: false })
    public layoutSup: boolean | any;
    public Success: boolean | any;
    public isFaild: boolean | any;
    public isPublic: boolean = true;
    public User: any;
    public async created() {
        this.isFaild = this.$route.query.isSuccess.toString().toLowerCase() === 'false' ? true : false;
        const pendingRenewalToast = takeRenewalDashboardSuccessToastPending();
        if (pendingRenewalToast) {
            if (this.isFaild) {
                Toaster.error(this.$t('shared.senderRenewalRequestPaymentFailedStillPending').toString());
            } else {
                Toaster.success(this.$t('shared.senderRenewalRequestPaymentCompletedStatusUpdated').toString());
            }
        }
        if (takeTemplateRenewalsPendingToast()) {
            Toaster.success(this.$t('shared.templateRenewalsPendingPayment').toString());
        }
        if (this.tokenService) {
            const token = await this.tokenService.getToken();
            if (token) {
                this.isPublic = false;
            }
        }
    }
    public GotoDashboard() {
        clearRenewalPaymentRedirectMark();
        const target = takePaymentReturnTarget();
        const legacyMessageTemplate = this.$route.query.fromMessageTemplate === '1'
            || localStorage.getItem('paymentSource') === 'messageTemplate';
        localStorage.removeItem('paymentSource');
        let routeName = getRouteNameFromPaymentReturnTarget(target);
        if (routeName === 'Dashboard' && legacyMessageTemplate) {
            routeName = 'MessageTemplateDashboard';
        }
        this.$router.push({ name: routeName }).catch(() => undefined);
    }
}
